import { render, staticRenderFns } from "./branch.vue?vue&type=template&id=676cbf4a&scoped=true&"
import script from "./branch.vue?vue&type=script&lang=js&"
export * from "./branch.vue?vue&type=script&lang=js&"
import style0 from "./branch.vue?vue&type=style&index=0&id=676cbf4a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676cbf4a",
  null
  
)

export default component.exports